<template>
	<div class="fl-cabecalho cabecalho-modelo">
		<div class="row">
			<TituloCabecalho
				:titulo="titulo"
				:sub-titulo="subTitulo"
				:submenu-modulo="submenuModulo"
				:icon-cabecalho="iconCabecalho"
				class="col-xs-12"
				:class="{'col-md-6': !exibeCadastro, 'col-md-10': exibeCadastro}"
			/>

			<div v-show="!exibeCadastro && exibeOpicoes">
				<IconeCadastro
					v-if="exibeIconeCadastro"
					:visualizar="visualizar"
					:cadastro-novo="cadastroNovo"
					class="col-md-4 col-xs-6"
				/>
				<BotaoVoltarCabecalho
					v-if="exibeVoltar"
					@click="clickVoltar"
					class="col-md-2 col-xs-12"
					:class="exibeIconeCadastro ? '' : 'pull-right'"
				/>
			</div>

			<div v-show="exibeCadastro && exibeOpicoes && exibeNovo">
				<BotaoNovoCabecalho @click="clickNovo" class="col-md-2 col-xs-12" />
			</div>

			<button
				v-tooltip="'Imprimir'"
				class="btn btn-default pull-right btn-lg"
				style="margin-right: 20px"
				:title="_traducao('global', 'imprimir')"
				@click="clickImprimir ? clickImprimir() : _print()"
				v-show="exibeImprimir"
			>
				<i class="icon-imprimir" style="font-size: 18px"></i>
			</button>
		</div>
	</div>
</template>

<script>
import TituloCabecalho from './titulo.vue'
import IconeCadastro from './icone-cadastro.vue'
import BotaoVoltarCabecalho from './botao-voltar.vue'
import BotaoNovoCabecalho from './botao-novo.vue'
export default {
	components: {
		TituloCabecalho,
		IconeCadastro,
		BotaoVoltarCabecalho,
		BotaoNovoCabecalho
	},

	props: {
		visualizar: {
			type: Boolean,
			default: false
		},
		titulo: {
			type: String,
			default: ''
		},
		subTitulo: {
			type: String,
			default: ''
		},
		exibeNovo: {
			type: Boolean,
			required: false,
			default: true
		},
		iconCabecalho: {
			type: String,
			required: false,
			default: 'icon-novo_cadastro'
		},
		exibeCadastro: {
			type: Boolean,
			default: false
		},
		cadastroNovo: {
			type: Boolean,
			default: true
		},
		rotaVoltar: {
			type: String,
			default: ''
		},
		submenuModulo: {
			type: String,
			default: 'ad'
		},
		exibeIconeCadastro: {
			type: Boolean,
			required: false,
			default: true
		},
		exibeVoltar: {
			type: Boolean,
			required: false,
			default: true
		},
		exibeImprimir: {
			type: Boolean,
			required: false,
			default: false
		},
		clickImprimir: {
			type: Function
		},
		exibeOpicoes: {
			type: Boolean,
			required: false,
			default: true
		}
	},

	methods: {
		clickVoltar() {
			if (this.rotaVoltar) {
				this.$router.push({name: this.rotaVoltar})
			} else {
				this.$emit('click-voltar')
			}
		},
		clickNovo() {
			this.$emit('click-novo')
		}
	}
}
</script>

<style>
.cabecalho-modelo {
	margin-bottom: 10px;
}
</style>